<template>
  <div class="software-data-cell">
    <v-badge
      tile
      overlap
      :icon="badgeIcon"
      :content="badgeContent"
      class="software-badge"
      :class="{ 'copied-badge': copied }"
      :value="copied"
    >
      <custom-tooltip v-if="value !== 'N/A'" :content="value" placement="top" popper-class="light-tooltip">
        <div class="software-data-cell__value" @click="copyValue">{{ value }}</div>
      </custom-tooltip>
      <div v-else class="software-data-cell__value software-data-cell__value--na">{{ value }}</div>
    </v-badge>
  </div>
</template>

<script>
import CustomTooltip from '@/components/common/CustomTooltip.vue';

export default {
  name: 'SoftwareTableCell',
  components: { CustomTooltip },
  props: {
    item: { type: Object, required: true },
    column: { type: Object, required: true },
  },
  data() {
    return { copied: false };
  },
  computed: {
    value() {
      const raw = this.item.software;
      return raw && raw.toLowerCase() !== 'unknown' ? raw : 'N/A';
    },
    badgeIcon() { return 'build'; },
    badgeContent() { return this.$t('copied'); },
  },
  methods: {
    async copyValue() {
      await navigator.clipboard.writeText(this.value);
      this.copied = true;
      await new Promise(resolve => setTimeout(resolve, 2000));
      this.copied = false;
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@/assets/styles/design-system';

.software-data-cell {
  overflow: hidden;
  width: 100%;

  &__value {
    color: var(--text-primary);
    font-size: $font-size-sm;
    font-family: $font-family-regular;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: pointer;

    &--na {
      cursor: default;
    }
  }
}
</style>

<style lang="scss">
@import '~@/assets/styles/design-system';

.software-data-cell {
  .software-badge {
    max-width: 100%;
    .v-badge__wrapper .v-badge__badge {
      font-family: $font-family-medium !important;
      background: transparent !important;
      border: none !important;
      color: var(--text-secondary);
      .v-icon { font-size: rem(16); transform: rotate(180deg); }
    }
    &.copied-badge .v-badge__wrapper .v-badge__badge {
      right: rem(20) !important;
      inset: auto auto calc(100% - 1px) calc(100% - 30px) !important;
    }
  }
}
</style>
